/* No forms, input names, telemetry, or remote personal-data requests. */
(() => {
  'use strict';
  const element=(tag,text,className)=>{const node=document.createElement(tag);if(text!==undefined)node.textContent=text;if(className)node.className=className;return node;};
  class MoonmeetChart extends HTMLElement {
    connectedCallback() {
      if(this.controller) return;
      this.controller=new AbortController(); this.sequence=(this.sequence||0)+1;
      this.labels=JSON.parse(this.dataset.labels); this.signs=this.labels.signs.split('|');
      this.q=name=>this.querySelector(`[data-${name}]`);
      this.date=this.q('birth-date');this.time=this.q('birth-time');this.cityInput=this.q('city');this.results=this.q('results');
      this.full=false;this.city=null;this.cityRows=[];this.matches=[];this.active=-1;this.repeatKey='';
      this.storage=window.MoonmeetChartStorage;
      const on=(target,event,fn)=>target.addEventListener(event,fn,{signal:this.controller.signal});
      // Clearing private details must not depend on an astronomy/timezone download.
      if(this.storage){on(this.q('clear'),'click',()=>this.clear());this.q('clear').disabled=false;}
      if(!window.MoonmeetChartCore || !window.temporal || !window.Astronomy || !window.MoonmeetChartWheel || !window.MoonmeetChartCities || !window.MoonmeetChartStorage) {this.status('timezone_dependency');return;}
      this.setMode();this.results.hidden=true;this.results.replaceChildren();this.q('repeat-wrap').hidden=true;this.q('repeat').replaceChildren();
      this.date.max=new Date(Date.now()+14*3600000).toISOString().slice(0,10);
      for(const name of ['discover','expand']) this.q(name).disabled=false;
      this.status('');this.preview();
      on(this.q('expand'),'click',()=>{this.full=!this.full;this.setMode();this.invalidate();if(this.full)this.q('unknown').focus();});
      on(this.q('unknown'),'change',()=>{this.setMode();this.invalidate();});
      for(const input of [this.date,this.time]) {
        on(input,'input',()=>{this.invalidate();if(input===this.date)this.preview();});
        on(input,'keydown',e=>{if(e.key==='Enter'){e.preventDefault();this.calculate();}});
      }
      on(this.cityInput,'focus',()=>this.loadCities());
      on(this.cityInput,'input',()=>{this.city=null;this.invalidate();this.searchCities();});
      on(this.cityInput,'keydown',e=>this.cityKeys(e));
      on(this.cityInput,'blur',()=>this.closeCities());
      on(this.q('city-options'),'pointerdown',e=>e.preventDefault());
      on(this.q('city-options'),'click',e=>{const option=e.target.closest('[data-city-index]');if(option)this.selectCity(Number(option.dataset.cityIndex));});
      on(this.q('repeat'),'change',()=>{this.results.hidden=true;this.status('');});
      on(this.q('discover'),'click',()=>this.calculate());
      on(this.q('remember'),'change',()=>{this.sequence++;if(!this.q('remember').checked)this.storageStatus(this.storage.clear()?'storage_cleared':'storage_blocked');else if(!this.storage.allowed())this.storageStatus('storage_memory');});
      on(document,'visitorConsentCollected',()=>{this.sequence++;if(!this.storage.allowed()){this.storageStatus(this.storage.clear()?'storage_memory':'storage_blocked');this.q('remember').checked=false;}});
      this.restore();
    }
    disconnectedCallback() {this.controller?.abort();this.controller=null;this.sequence++;}
    status(key) {this.q('chart-status').textContent=this.labels[key]||'';}
    storageStatus(key) {this.q('storage-status').textContent=this.labels[key];}
    setMode() {
      this.q('details').hidden=!this.full;this.q('expand').setAttribute('aria-expanded',String(this.full));
      const disabled=!this.full||this.q('unknown').checked;
      this.time.disabled=disabled;this.cityInput.disabled=disabled;
      this.closeCities();
    }
    invalidate() {
      this.dataset.chartState='editing';
      this.sequence++;this.q('starter')?.removeAttribute('hidden');this.results.hidden=true;this.results.replaceChildren();this.repeatKey='';this.q('repeat-wrap').hidden=true;this.q('repeat').replaceChildren();this.status('');
      // Never leave a previously remembered birthday silently behind an edit.
      if(this.q('remember').checked)this.storageStatus(this.storage.clear()?'storage_cleared':'storage_blocked');
    }
    preview() {
      const holder=this.q('starter');if(!holder||!window.MoonmeetChartWheel)return;
      holder.hidden=false;
      let result;
      try { if(this.date.value) {if(this.previewDate!==this.date.value){this.previewResult=window.MoonmeetChartCore.quick(this.date.value);this.previewDate=this.date.value;}result=this.previewResult;} } catch {this.previewDate='';this.previewResult=null;}
      const sign=result?.possible.length===1?result.possible[0]:undefined;
      holder.dataset.previewState=result?(sign===undefined?'uncertain':'birthday'):'starter';
      this.q('preview-wheel').replaceChildren(window.MoonmeetChartWheel([],this.signs,this.labels,()=>'',{sign}));
      this.q('preview-note').textContent=this.labels[result?(sign===undefined?'cusp_note':'birthday_note'):'preview_note'];
      this.q('preview-sun').textContent=result?(sign===undefined?result.possible.map(i=>this.signs[i]).join(` ${this.labels.between} `):this.signs[sign]):this.labels.sun_pending;
    }
    async loadCities() {
      if(this.cityRows.length){this.searchCities();return;}
      this.q('city-status').textContent=this.labels.loading;
      try {
        const cities=await window.MoonmeetChartCities.load(this.dataset.citiesUrl);
        if(!this.isConnected)return;
        this.cityRows=cities;
        if(document.activeElement===this.cityInput)this.searchCities();else this.q('city-status').textContent='';
      } catch {if(this.isConnected)this.q('city-status').textContent=this.labels.cities;}
    }
    searchCities() {
      if(!this.cityRows.length){this.loadCities();return;}
      this.matches=window.MoonmeetChartCities.search(this.cityRows,this.cityInput.value);this.active=-1;
      const list=this.q('city-options');list.replaceChildren();
      this.matches.forEach((city,i)=>{
        const option=element('li',`${city.label} · ${city.latitude.toFixed(2)}°, ${city.longitude.toFixed(2)}°`);
        option.id=`${list.id}-${i}`;option.dataset.cityIndex=i;option.setAttribute('role','option');option.setAttribute('aria-selected','false');list.append(option);
      });
      list.hidden=!this.matches.length;this.cityInput.setAttribute('aria-expanded',String(!list.hidden));this.cityInput.removeAttribute('aria-activedescendant');
      this.q('city-status').textContent=this.city?`${this.labels.selected}: ${this.city.label} · ${this.city.zone}`:this.cityInput.value.trim().length<2?'':this.labels[this.matches.length?'city_count':'no_cities'];
    }
    closeCities() {this.q('city-options').hidden=true;this.cityInput.setAttribute('aria-expanded','false');this.cityInput.removeAttribute('aria-activedescendant');}
    cityKeys(event) {
      if(event.key==='Escape'){this.closeCities();return;}
      if(['ArrowDown','ArrowUp'].includes(event.key)&&this.matches.length) {
        event.preventDefault();const step=event.key==='ArrowDown'?1:-1;this.active=this.active<0?(step>0?0:this.matches.length-1):(this.active+step+this.matches.length)%this.matches.length;
        const options=[...this.q('city-options').children];options.forEach((n,i)=>n.setAttribute('aria-selected',String(i===this.active)));
        this.q('city-options').hidden=false;this.cityInput.setAttribute('aria-expanded','true');this.cityInput.setAttribute('aria-activedescendant',options[this.active].id);options[this.active].scrollIntoView({block:'nearest'});
      } else if(event.key==='Enter') {event.preventDefault();if(this.active>=0&&!this.q('city-options').hidden)this.selectCity(this.active);}
    }
    selectCity(index) {
      this.city=this.matches[index];if(!this.city)return;
      this.invalidate();this.cityInput.value=this.city.label;this.closeCities();this.q('city-status').textContent=`${this.labels.selected}: ${this.city.label} · ${this.city.zone}`;
    }
    async restore() {
      const saved=this.storage.read();if(!saved)return;
      const sequence=this.sequence;
      try {
        window.MoonmeetTimezones.date(saved.date);
        let city=null;
        if(saved.cityId!==null) {
          const rows=await window.MoonmeetChartCities.load(this.dataset.citiesUrl);
          city=rows.find(row=>row.id===saved.cityId);if(!city)throw Error('storage');
          if(sequence!==this.sequence||!this.isConnected||!this.storage.allowed())return;
          this.cityRows=rows;
        }
        if(sequence!==this.sequence||!this.storage.allowed())return;
        this.date.value=saved.date;this.time.value=saved.time;this.full=saved.full;this.q('unknown').checked=saved.unknown;this.city=city;this.cityInput.value=city?.label||'';this.preview();this.q('remember').checked=true;this.setMode();this.storageStatus('restored');
      } catch {this.storage.clear();this.storageStatus('storage_memory');}
    }
    save() {
      if(!this.q('remember').checked)return;
      const timed=this.full&&!this.q('unknown').checked;
      const ok=this.storage.write({date:this.date.value,time:timed?this.time.value:'',cityId:timed?this.city?.id||null:null,full:this.full,unknown:this.q('unknown').checked});
      this.storageStatus(ok?'storage_saved':'storage_memory');
    }
    clear() {
      this.previewDate='';this.previewResult=null;
      this.invalidate();this.date.value='';this.time.value='';this.cityInput.value='';this.city=null;this.matches=[];this.active=-1;this.q('city-options').replaceChildren();this.full=false;this.q('unknown').checked=false;this.q('remember').checked=false;this.setMode();this.q('city-status').textContent='';this.storageStatus(this.storage.clear()?'storage_cleared':'storage_blocked');this.preview();this.date.focus();
    }
    calculate() {
      this.results.hidden=true;this.results.replaceChildren();
      try {
        window.MoonmeetTimezones.date(this.date.value);
        let result;
        if(!this.full||this.q('unknown').checked)result=window.MoonmeetChartCore.quick(this.date.value);
        else {
          if(!this.time.value)throw Error('time');
          if(!this.city)throw Error('city_required');
          const resolved=window.MoonmeetTimezones.resolve(this.date.value,this.time.value,this.city.zone);
          if(!['ready','ambiguous'].includes(resolved.status))throw Error(resolved.status);
          let selected=resolved.candidates[0];
          if(resolved.status==='ambiguous') {
            const key=`${this.date.value}/${this.time.value}/${this.city.id}`;
            if(key!==this.repeatKey) {
              this.repeatKey=key;const select=this.q('repeat');select.replaceChildren(new Option(this.labels.choose_prompt,''));
              for(const candidate of resolved.candidates)select.add(new Option(`UTC${candidate.offset} · ${candidate.utc}`,String(candidate.time)));
              this.q('repeat-wrap').hidden=false;
            }
            selected=resolved.candidates.find(candidate=>String(candidate.time)===this.q('repeat').value);
            if(!selected){this.status('choose_time');this.q('repeat').focus();return;}
          }
          result=window.MoonmeetChartCore.snapshot(selected.time,this.city);
          result.offset=selected.offset;
        }
        this.render(result);this.save();this.status('ready');this.results.hidden=false;this.results.focus();
      } catch(error) {
        const code=this.labels[error.message]?error.message:'calculation';this.status(code);
        const input=code.startsWith('date')?this.date:code==='time'?this.time:code==='city_required'?this.cityInput:null;input?.focus();
      }
    }
    describe(p) {
      const names=p.possible.map(i=>this.signs[i]).join(` ${this.labels.between} `);
      const degrees=new Intl.NumberFormat(document.documentElement.lang||'en',{maximumFractionDigits:1,minimumFractionDigits:1}).format(Math.floor(p.degree*10)/10);
      return p.possible.length>1?`${names} · ${this.labels.boundary}`:`${names} · ${degrees}°`;
    }
    render(result) {
      const l=this.labels, target=this.results;
      this.dataset.chartState=result.mode;
      if(result.mode==='quick')this.preview();else this.q('starter').hidden=true;
      target.append(element('p',l[result.mode==='quick'?'birthday_result':'calculated'],'mm-eyebrow'),element('h2',l[result.mode==='quick'?(result.possible.length===1?'sun_confident':'sun_uncertain'):'snapshot']));
      if(result.mode==='quick') {
        target.append(element('p',result.possible.map(i=>this.signs[i]).join(` ${l.between} `),'mm-chart__sun'),element('p',l.quick_note));
        if(result.possible.length>1)target.append(element('p',l.cusp_note));
        else target.append(element('p',l.symbolic,'mm-eyebrow'),element('p',l[`sun_${result.possible[0]}`]));
      } else {
        const context=element('p',`${l.time_resolved}: ${new Date(result.time).toISOString()} · ${l.place_resolved}: ${this.city.label} · ${this.city.zone} (UTC${result.offset})`,'mm-chart__hint');target.append(context);
        const bigThree=element('div',undefined,'mm-chart__trio');
        for(const [index,role] of ['sun','moon','rising'].entries()) {
          const p=index===2?result.ascendant:result.planets[index],card=element('article',undefined,'mm-card');card.append(element('p',l[`${role}_role`],'mm-eyebrow'));
          if(p.available===false)card.append(element('h3','—'),element('p',l.polar));
          else {
            card.append(element('h3',this.describe(p)),element('p',l.symbolic,'mm-chart__hint'),element('p',p.possible.length>1?l.uncertain_note:l[`${role}_${p.sign}`]));
          }
          bigThree.append(card);
        }
        target.append(bigThree);
        const placements=[...result.planets];if(result.ascendant.available)placements.push({body:'Rising',...result.ascendant});
        const grid=element('div',undefined,'mm-chart__sky'),figure=element('figure');figure.append(window.MoonmeetChartWheel(placements,this.signs,l,p=>this.describe(p)),element('figcaption',l.wheel_note));
        const list=element('ol',undefined,'mm-chart__placements');
        for(const p of placements) {
          const li=element('li');li.append(element('strong',l[p.body]),element('span',this.describe(p)));list.append(li);
        }
        const values=element('div');values.append(element('h3',l.calculated),list);grid.append(figure,values);target.append(grid,element('p',l.accuracy_note,'mm-chart__hint'));
      }
      const edit=element('button',l.edit,'mm-text-link');edit.type='button';edit.addEventListener('click',()=>{this.results.hidden=true;this.date.focus();},{signal:this.controller.signal});target.append(edit);
    }
  }
  if(!customElements.get('moonmeet-chart'))customElements.define('moonmeet-chart',MoonmeetChart);
})();
